<template>
  <v-form>
  <div class="ma-5 ml-3 site_content">
    <div class="flex as__container">
        <div class="notice__container">
          <div class="flex align-center mt-10">
            <img class="as_icon" :src="require('@/assets/client/as_register.svg')" />
            <span class="as_title">A/S 접수</span>
          </div>
          <div class="as_notice">
            A/S와 관련된 문의사항은 아래 입력란에 기재해 주세요. <br/>
            접수된 순서에 따라 순차적으로 확인 및 처리되며,  담당자가 확인 후 등록된 연락처로 연락을 드릴 예정입니다.
          </div>
        </div>

        <div class="register__container mr-2">
          <div class="register_content">
            <div class="flex">
              <div class="flex align-center">
                <div class="register_title"> 사업장명 *</div>
                <v-select dense outlined
                  class=""
                  id="farm" 
                  ref="farm" 
                  v-model="farm"
                  :items="farmItems"
                  :menu-props="{ top: false, offsetY: true }"
                  item-text="name"
                  return-object
                  @focus="comboFarms()"
                />
                <!-- {{ this.farm.name }}  / {{ this.as_item.name }} / {{ this.title }} -->
              </div>

              <div class="flex align-center mt-2">
                <div class="register_title"> A/S 항목 *</div>
                <v-select dense outlined 
                  id="as_item" 
                  v-model="as_item" 
                  ref="as_item" 
                  class=""
                  :items="asItems"
                  item-text="name"
                  :menu-props="{ top: false, offsetY: true }"
                  return-object
                />
              </div>
            </div>

            <div class="flex">
              <div class="flex align-center mt-2">
                <div class="register_title"> 전화번호 *</div>
                <v-text-field dense outlined
                  style=""
                  class="textfield"
                  id="phone" 
                  ref="phone" 
                  placeholder="숫자만 입력"
                  v-model="phone"
                  @keyup="phone ? getPhoneMask(phone) : null"
                />
              </div>

              <div class="flex align-center mt-2">
                <div class="register_title"> 연락가능 시간대</div>
                <v-text-field dense outlined
                  style=""
                  class="textfield"
                  id="contactable_time" 
                  ref="contactable_time" 
                  v-model="contactable_time"
                />
              </div>
            </div>

            <div class="flex align-center mt-2">
              <div class="register_title"> 제목 *</div>
              <v-text-field dense outlined
                style="max-width:50vw;"
                class="textfield"
                id="title" 
                ref="title" 
                v-model="title"
              />
            </div>

            <div class="mt-2">
              <div class="register_title"> 문의내용</div>
              <v-textarea
                v-model="contents"
                outlined
                class="textarea"
                rows="6"
                required
                counter="1000"
              />
            </div>

            <div class="flex vertical-center">
              <v-btn class="normal-btn mb-3" 
                style="color:white !important;"
                @click="save()">
                제출하기
              </v-btn>
            </div>

            <v-dialog v-model="save_dialog" max-width="450">
              <v-card>
                <div class="dialog_title">접수완료</div>
                <div class="dialog_content">
                  A/S 등록이 완료되었습니다.<br/>
                  접수된 순서에 따라 순차적으로 확인 및 처리됩니다.
                </div>
                <div class="btn-content">
                  <v-btn class="vertify_btn" @click="save_dialog=false" style="color:white !important;">확인</v-btn>
                </div>
              </v-card>
            </v-dialog>
          </div>
      </div>

      <div class="list_content">
        <v-btn class="normal-btn list-btn" style="color:#005B96 !important;"
          @click="goList()">
            <v-icon size="20" class="mr-1">mdi-history</v-icon>
            A/S 내역
          </v-btn>
        </div>
      </div>
    </div>
  </v-form>
</template>

<script>
import Common from "@/utils/custom/common.js";
import Apis from '@/api/apis'
import dateUtil from "@/utils/custom/dateProperty.js";
// import historyTable from "./history/historyTable.vue";


export default {
  name: 'AsRegister',
  components: {
    // historyTable,
  },
  data: () => ({
    farmItems:[],
    farm:{},

    as_item:{},
    asItems : Common.comboBaseCode("AS"),

    phone:'',
    contactable_time:'',
    title:'',
    contents:'',

    save_dialog:false,



  }),
  async created(){
    // this.comboFarms();
    Apis.pageCount({
      page_name: this.$route.name,
      url: this.$route.path,
      division: "cloud",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });

    await this.comboFarms();

  },
  methods:{
    save() {
      this.$store.commit("resMessage", "");

      const msgCheckdata = this.checkData();
      if (msgCheckdata) {
        this.$store.commit("resMessage", msgCheckdata);
        return;
      }
      Apis.insertAsHead({
        farm_cd: this.farm.code,
        division1: this.as_item.code, 
        title: this.title, 
        phone: this.phone,
        email: '',
        contactable_time : this.contactable_time || '',
        contents: this.contents || '',
        process_status : 1,
        etc1:'',
        etc2:'',
      }, (res) => {
        if (res.result) {
          this.sendSMS();
          this.save_dialog = true;
          this.$store.commit("resMessage", res.message);
          
          this.clearData();
        } else {
          alert(res.message);
        }
      }).catch((err) => {
        console.log("insertAsHead API 호출 오류", err);
        alert(err);
      });
    },
    sendSMS(){
      // console.log('사업장', this.farm.name);
      // console.log('항목', this.as_item.name)
      // console.log('제목', this.title)

      const receivers = ["010-9732-4268", "010-2106-4630"];

      receivers.forEach(receiver => {
        Apis.sendSMS({
          receiver: receiver,
          message : `A/S 접수 알림\n
사업장명 : ${this.farm.name}\nA/S항목 : ${this.as_item.name}\n`,
          farm_cd : this.farm.code
        }, (res) => {
          if (res.result) {
            // console.log("SMS전송완료")
          } else {
            alert(res.message);
          }
        }).catch((err) => {
          console.log("sendSMS API 호출 오류", err);
          alert(err);
        });
      });
//       Apis.sendSMS({
//         receiver : "010-8454-9884",
//         message : `A/S 접수 알림\n
// 사업장명 : ${this.farm.name}\nA/S항목 : ${this.as_item.name}\n`,
//         farm_cd : this.farm.code
//       }, (res) => {
//         if (res.result) {
//           // console.log("SMS전송완료")
//         } else {
//           alert(res.message);
//         }
//       }).catch((err) => {
//         console.log("sendSMS API 호출 오류", err);
//         alert(err);
//       });
    },
    checkData(){
      if (!this.farm.code) {
        this.$refs.farm.focus();
        return "사업장을 선택하세요";
      }
      if (!this.as_item.code) {
        this.$refs.as_item.focus();
        return "A/S 항목을 선택하세요";
      }
      if (!this.phone.trim()) {
        this.$refs.phone.focus();
        return "핸드폰 번호를 입력하세요";
      }
      if (!this.title.trim()) {
        this.$refs.title.focus();
        return "문의 제목을 입력하세요";
      }
      return "";
    },
    clearData(){
      this.farm = {},
      this.as_item = {},
      this.phone = '',
      this.contactable_time = '',
      this.title = '',
      this.contents = ''
    },
    async comboFarms() {
      await Apis.comboFarms({
        company_cd: "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          // console.log(res)
          if (res.result) {
            this.farmItems = [];
            for (let i in res.data) {
            this.farmItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              code: res.data[i].farm_cd,
              name: res.data[i].farm_name,
              biz : res.data[i].farm_biz
              });
            }  

            if (this.farmItems.length > 0) {
              this.farm = this.farmItems[0];
            }
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    getPhoneMask(val) {
      // console.log(val)
      this.phone = Common.getMask(val)
    },
    goList(){
      this.$router.push("/client/aslist");
    },
    // infoDetail(item){
    //   console.log('클릭클릭:', item);
    // }
  }
}
</script>

<style scoped  lang="scss">
@import '../info/info_style/info_style.scss';
.as_title{
  font-size:22px;
  color:$main-color;
  font-weight:600;
  letter-spacing: -1.75px;
}
.as_notice{
  font-size:15px;
  letter-spacing: -1px;
  color:#6A6A6A;
}
.as__container{
  width:100%;
  margin-top:10px;
  display:flex;
  flex-direction:column;
  align-items:center;
}
.notice__container{
  width: 80%; 
  align-self: flex-start;
  margin-left: 10%;
  margin-bottom:15px;
}
.register__container, .history__container{
  width:80%;
  background-color:white;
  box-shadow: 2px 3px 4px 0px #bebebe !important;
  letter-spacing: -0.75px;
  border-radius: 30px;
  overflow: hidden;
}
.register__container{
  background-color: white;
  // border-radius: 30px;
}
.register_content{
  padding:15px 30px;
}
.register_title{
  color: #707070;
  font-weight:550;
  width:120px;
}
.textarea{
  min-height:250px;
}
::v-deep .textarea .v-input__slot{
  min-height:280px !important;
  overflow-y: auto !important;
}
::v-deep .textarea .v-text-field__slot{
  min-height:250px;
}

.normal-btn{
  min-width:110px !important;
  color:white !important;
  height: 50px !important;
  margin-top:50px;
}
.list-btn{
  background-color:$menu-color !important;
  margin-top:10px;
  min-width:140px !important;
}
.list_content{
  align-self:end; 
  margin-right:10%;
}
.dialog_title{
  padding:10px 20px;
  background-color: $main-color;
  color:white;
  font-size:18px;
  font-weight:600;
}
.dialog_content{
  padding:20px;
  font-size:17px;
  letter-spacing: -1px;
}
.btn-content{
  display: flex;
  justify-content: end;
  padding:5px 20px 15px;
}
.vertify_btn{
  background-color:$main-color !important;
  border-radius: 20px !important;
  height:40px !important;

}
</style>